import { render } from "./UploadRecordManage.vue?vue&type=template&id=e110a940"
import script from "./UploadRecordManage.vue?vue&type=script&lang=js"
export * from "./UploadRecordManage.vue?vue&type=script&lang=js"

import "./UploadRecordManage.vue?vue&type=style&index=0&id=e110a940&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__